var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { getAllGames } from "../../../../actions/games/creators";
import GamesList from "../GamesList";
import { SectionGames } from "../styles";
var messages = defineMessages({
    allGames: {
        id: "games.all_games",
        defaultMessage: "Все игры",
    },
    noGames: {
        id: "games.no_games",
        defaultMessage: "Нет игр",
    },
    loading: {
        id: "loading",
        defineMessages: "Загрузка..."
    }
});
var AllGames = /** @class */ (function (_super) {
    __extends(AllGames, _super);
    function AllGames() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllGames.prototype.render = function () {
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, data = _a.data, isLoading = _a.isLoading, backGamesPage = _a.backGamesPage;
        var allGames = data.Items;
        return (_jsxs("div", { children: [_jsxs(SectionGames, __assign({ darkTheme: darkTheme }, { children: [intl.formatMessage(messages.allGames), _jsx("div", { className: "clear-icon", onClick: backGamesPage })] })), !allGames.length && !isLoading && (_jsx("h3", __assign({ style: { textAlign: "center", padding: "20px 0" } }, { children: intl.formatMessage(messages.noGames) }))), !allGames.length && isLoading && (_jsx("div", __assign({ style: { padding: "10px", textAlign: "center" } }, { children: intl.formatMessage(messages.loading) }))), _jsx(GamesList, { fetchData: this.props.getAllGamesAction })] }));
    };
    return AllGames;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, data = _a.data, error = _a.error, isLoading = _a.isLoading;
    var openGamesLoading = state.games.openGame.isLoading;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        openGamesLoading: openGamesLoading,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    getAllGamesAction: getAllGames,
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AllGames));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesAllGames/GamesAllGames.jsx